module.exports = __webpack_public_path__ + "static/media/retention.774df2e6.png";